import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import api from 'api';
import { redirect404, checkResourcePath } from 'helpers';
import { PageMarkup } from 'views/Page';

import { 
    setCurrentView,
} from 'store';

class Post extends Component {

    componentDidMount() {
        this.mounted = true;
        this._loadPageData();
    }

    componentDidUpdate(prevProps) {
        if(this.props.location.pathname !== prevProps.location.pathname) {
            this._loadPageData();
        }
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    _loadPageData() {

        this.props.setCurrentView(null);

        api.postFetcher
            .getBySlug({ slug: this.props.match.params.slug })
                .then(resp => {
                    const post = resp.data[0];
                    if(post.id) {
                        if(!api.postFetcher.middleware.requestingPagePreview()) {
                            // checkResourcePath() will redirect to 404 if resource.link !== location.pathname
                            if(!checkResourcePath(post, this.props.location)) return;
                        }
                        this.props.setCurrentView(post);
                    } else {
                        redirect404();
                    }
                });
    }

    render() {
        const { post } = this.props;

        return <PageMarkup page={post} />
    }
}

const mapStateToProps = state => {
    return {
        post: state.currentView,
    }
}


const actions = {
    setCurrentView,
}

export default connect(mapStateToProps, actions)(withRouter(Post));